import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Importamos useLocation
import { useCart } from '../context/CartContext'; // Importamos el contexto de carrito
import { FaShoppingCart } from 'react-icons/fa'; // Importamos el ícono de carrito desde react-icons/fa
import "./Navbar.css";

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation(); // Hook para obtener la ruta actual
  const { getTotalItems } = useCart(); // Usamos getTotalItems del contexto

  // Cerrar el menú cuando cambia la página
  React.useEffect(() => {
    setIsOpen(false);

     // Hacer scroll hacia arriba cada vez que se cambia la ruta
     window.scrollTo(0, 0); 
  }, [location]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Función para determinar si el enlace está activo
  const isActiveLink = (path) => {
    return location.pathname === path ? "active-link" : "";
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">
          <img src={require("../assets/logo.jpg")} alt="Pojobox Logo" />
        </Link>
      </div>

      {/* Icono de hamburguesa */}
      <div className={`hamburger ${isOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Menú */}
      <ul className={`menu ${isOpen ? "show" : ""}`}>
        <li>
          <Link to="/" className={isActiveLink("/")}>Inicio</Link>
        </li>
        <li>
          <Link to="/products" className={isActiveLink("/products")}>Productos</Link>
        </li>
        <li>
          <Link to="/contact" className={isActiveLink("/contact")}>Contacto</Link>
        </li>
        <li className="submenu-container">
          <Link to="/resellers" className={isActiveLink("/resellers")}>
            Revendedores
          </Link>
        </li>
        <li>
          <a href="https://pojo-box.vercel.app/" target="_blank" rel="noopener noreferrer">Pojobox Tech</a>
        </li>

        {/* Icono del carrito con el número de productos */}
        <li className="cart-icon">
          <Link to="/cart">
            <FaShoppingCart /> {/* Ícono de carrito de react-icons */}
            {getTotalItems() > 0 && (
              <span className="cart-item-count">{getTotalItems()}</span>
            )}
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar;
